module.exports = __webpack_public_path__ + "img/maker_tst.79106a01.jpg";